export default __webpack_public_path__ + "static/media/meme_coin_up_black.d4866755.svg";